import { render } from "./SquadDutyTab.vue?vue&type=template&id=1f952f34"
import script from "./SquadDutyTab.vue?vue&type=script&lang=js"
export * from "./SquadDutyTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__